<script>
export default {
  name: 'EbDropdownDivider',
  functional: true,
  render(createElement) {
    return createElement(
      'div',
      {
        class: {
          'dropdown-divider': true
        }
      },
      ['']
    );
  }
};
</script>

<style scoped>
.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}
</style>